module.exports = __webpack_public_path__ + "img/2_10_02.35ee75cc.png";